module.exports = __webpack_public_path__ + "static/img/蒙版组 4@2x.d71a4a53.png";